import { getMulticardCanonicalPath, type MulticardUrlResolution } from '~/utils/multicardSeo';

// eslint-disable-next-line no-unused-vars
export default defineNuxtRouteMiddleware(async (to, _from) => {
  const { appUrl } = useRuntimeConfig().public;
  const multicardUrlResolution = useState<MulticardUrlResolution | null>('multicard-url-resolution', () => null);

  useHead({
    link: [
      {
        key: 'canonical',
        rel: 'canonical',
        href: computed(() => appUrl + getMulticardCanonicalPath(to.path, multicardUrlResolution.value)),
      },
    ],
  });
});
